import React, { FC } from 'react';
import { RelocationSiteFormProps } from './RelocationSiteFormProps';
import LocationInfoFields from '../LocationInfoFields';
import SiteInfoFields from '../SiteInfoFields';
import SiteProgressInfoFields from '../SiteProgressInfoFields';

const RelocationSiteForm: FC<RelocationSiteFormProps> = ({
  countries,
  onCountryChange,
  BuList,
  isep,
  onBUChange,
  transactionType,
  isLeasedFromAnotherIngkaCompany,
  currencyRate,
  currency,
  isEdit,
}) => {
  return (
    <>
      <LocationInfoFields
        countries={countries}
        locationName
        buCode
        BUList={BuList}
        isep={isep}
        buCodeRequired
        onCountryChange={onCountryChange}
        onBUChange={onBUChange}
        isEdit={isEdit}
      />
      <SiteInfoFields
        unitType
        transactionType={transactionType}
        isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
        land
        lease
        building
        currencyRate={currencyRate}
        currency={currency}
      />
      <SiteProgressInfoFields />
    </>
  );
};

export default RelocationSiteForm;
